<template>
  <div :class="['productsMain','theme_'+this.$route.params.version]">
    <h1>
        PRODUCTS
         <!-- {{this.$route.params.version}} -->
    </h1>
    <!-- <research-ops></research-ops> -->    
    <div>
      <div ref="accPanels1" :class="['accordion mx-2xl']"><!-- @mouseleave="activeIndex = -1" , 'mx-2xl' -->        
        <div :class="['accItem',activeIndex == index ? 'active':'']"
          v-for="(item, index) in children"
          :key="index"
            @mouseenter="setActiveIndex(index)" >                 
            <video :id="'accVideo'+index" class="accVideo"
                :src="item.video" 
                muted="muted" 
                loop="loop" 
                playsinline="">
            </video>    
            <div class="accMenu px-l">
                <h2>{{item.title}}</h2>
                <div class="accMenuList">
                    <a class="text--m mb-xs" v-for="linkItem in item.children" :key="linkItem">
                        {{linkItem}}
                    </a>
                </div>
            </div>        
        </div>

<!-- @mouseenter.native="activeIndex = index" > autoplay="autoplay"  -->

<!--         <div style="color:black;">
          activeIndex = {{activeIndex}}<br/><br/>
        </div>
 -->
        <!--
        <hp-accordionitem
          v-for="(item, index) in children"
          :key="index"
          :item="item"
          :index="index"
          :isactive="activeIndex === index"
          :scrolledIndex = "currentPage"
          @mouseenter.native="activeIndex = index" >
        </hp-accordionitem>
        -->        
      </div>
    </div>

    <!-- ResearchOps -->

  </div>
</template>

<!-- v3 -->
<style scoped>

    .productsMain.theme_3                               {background: #202020;}
    .productsMain.theme_3 h1                            {color:#fff;}
    .productsMain.theme_3 .accItem                      {background: #202020;}
    .productsMain.theme_3 .accItem .accMenu h2          {color: #eee;}    
    .productsMain.theme_3 .accItem .accMenuList a       {color:#dadada;}
    .productsMain.theme_3 .accItem .accMenuList a:hover {color:#1894e2;}    
    .productsMain.theme_3 .accItem.active               {background: #202020;}
    .productsMain.theme_3 .accItem.active h2            {color: #fff;}    


    .productsMain.theme_2                               {background: transparent;}
    .productsMain.theme_2 h1                            {color:#202020;}
    .productsMain.theme_2 .accItem                      {background: #f9f9f9;}
    .productsMain.theme_2 .accItem .accMenu h2          {color: #202020;}    
    .productsMain.theme_2 .accItem .accMenuList a       {color:#dadada;}
    .productsMain.theme_2 .accItem .accMenuList a:hover {color:#1894e2;}    
    .productsMain.theme_2 .accItem.active               {background: #202020;}
    .productsMain.theme_2 .accItem.active h2            {color: #fff;}    


    .productsMain
    {
        width: 100%;
        min-height: 50vh;
        padding-top: 80px;
        padding-bottom: 200px;
        text-align: center;
    }
    .productsMain h1
    {
        margin: auto;text-align: center;width: 100%;
    }

    .accordion
    {        
        margin-top:30px;
        height: 65vh;
        max-height: 65vh;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: space-evenly;
        gap: 20px;
        border-radius: 20px;
    }
    .accItem 
    {
        flex: 1;
        transition: all 600ms ease-out-quad;
        border-radius: 20px;
        position: relative;
    }
    .accItem video
    {
        width: 100%;
        height: 46%;
        object-fit: cover;
        top: 0px;left: 0px;
        border-radius: 20px;
        opacity: 1;
        transition: all 600ms ease-out-quad;

    }
    .accItem .accMenu
    {
        top: 0px;left: 0px;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        background: none;    
        padding-top: 25px;    
    }
    .accItem .accMenu h2
    {
        transition: all 600ms ease-out-quad;
        opacity:0.5;
    }
    .accItem .accMenuList
    {
        padding-top: 15px;
        display: flex;
        flex-direction: column;
        opacity: 0;
        transition: all ease 0.3s;
    }
    .accItem .accMenuList a
    {
        font-size: 13px;
        text-align: left;
        box-sizing: border-box;    
        font-weight: 300 !important;    
        cursor: pointer;
    }
    .accItem .accMenuList a:hover
    {
        font-size: 13px;color:#1894e2;font-weight: 300 !important;    
    }    
    .accItem.active
    {
        flex: 2;
    }
    .accItem.active video
    {
        opacity: 1;
    }
    .accItem.active h2
    {
        opacity:1;
    }
    .accItem.active .accMenuList
    {
        opacity: 1;
    }






    .productsMain.theme_1 .productsMain
    {
        width: 100%;
        min-height: 50vh;
        padding-top: 80px;
        padding-bottom: 200px;
        text-align: center;
    }
    .productsMain.theme_1 h1{margin: auto;text-align: center;width: 100%;}
    .productsMain.theme_1 .accordion
    {        
        margin-top:55px;
        height: 60vh;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: space-evenly;
        gap: 20px;
        border-radius: 20px;
    }
    .productsMain.theme_1 .accItem 
    {
        flex: 1;
        transition: all 600ms ease-out-quad;
        background: #f9f9f9;
        border-radius: 20px;
        position: relative;
    }
    .productsMain.theme_1 .accItem video
    {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0px;left: 0px;
        border-radius: 20px;
        opacity: 0;
        transition: all 600ms ease-out-quad;
    }
    .productsMain.theme_1 .accItem .accMenu
    {
        position: absolute;
        top: 40px;left: 0px;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        background: none;        
    }
    .productsMain.theme_1 .accItem .accMenu h2
    {
        transition: all 600ms ease-out-quad;
    }
    .productsMain.theme_1 .accItem.active
    {
        flex: 2;
        background: #202020;
    }
    .productsMain.theme_1 .accItem.active h2
    {
        color: #fff;
    }
    .productsMain.theme_1 .accItem.active video
    {
        opacity: 1;
    }
    .productsMain.theme_1 .accItem .accMenuList
    {
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        opacity: 0;
        transition: all ease 0.3s;
    }
    .productsMain.theme_1 .accItem .accMenuList a
    {
        font-size: 16px;
        color:#fff;
        text-align: left;
        box-sizing: border-box;    
        font-weight: 300 !important;    
    }
    .productsMain.theme_1 .accItem.active .accMenuList
    {
        opacity: 1;
    }

</style>






<script>


  import { mapActions, mapState } from "vuex";
  /* import ResearchOps from "@/components/contact/ResearchOps.vue"; */

  export default 
  {
    data(){
      return{
        activeIndex: 0,
        minisite_ready:false,
        children:[
            {
                title:"Implant Systems",
                video:"https://mis-lynx.mis-implants.com/lynx/img/lynx.mp4",
                children:["C1 - Conical Connection","V3 - Conical Connection","SEVEN - Internal Hex.","M4 - Internal Hex.","Healing Caps","B+ Surface"]
            },
            {
                title:"Kits & Tools",
                video:"https://mis-lynx.mis-implants.com/lynx/img/lynx.mp4",
                children:["NEW: XD Drills"]
            },
            {
                title:"Prosthetic Options",
                video:"https://mis-implants.com/upload/home/global/videos/MIS_30_Anniversary_Video_web.mp4",
                children:["Impression Coping","Temporary Restoration","Screw Retained Restoration","Digital Restoration","Cemented Restoration","Overdenture"]
            },
            {
                title:"MGUIDE Guided Surgery", 
                video:"https://mguide.mis-implants.com/content/mguide/img/videos/MIS_Mguide_1.mp4",
                children:["MGUIDE","MIS MCENTERs","MGUIDE Videos","Stackable Guide Service"]
            },
            {
                title:"MIS Digital Workflow",
                video:"https://mis-lynx.mis-implants.com/lynx/img/lynx.mp4",
                children:[]
            }
        ]
      }
    },  
    components:
    {
        //ResearchOps
    }, 
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),

  },
  methods:
  {
    setActiveIndex(index)
    {
        this.activeIndex = index;

        var elementsParent = this.$refs.accPanels1;
        const elements = elementsParent.querySelectorAll('.accVideo');
        for (let i = 0; i < elements.length; i++) 
        {
            var videoElement = elements[i];
            if(this.activeIndex==i){
                videoElement.play();
            }else{
                videoElement.pause();
            }
        }

        //accPanels1
        var videoElementId = "'accVideo'+index";
    }
  },
  mounted()
  {
    var vm=this;
    this.setActiveIndex(0);
  },
  created()  
  {            
}   
  
  }
</script>


